module.exports = __webpack_public_path__ + "static/media/Teen_HoPro-dt-fr.155b5f38.jpg";